import axios from "axios";

const api = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL,
 headers: {
 "Content-Type": "application/json",
 },
});



/**
 * ===============================
 * CLIENT EVENTS SERVICE (PUBLIC)
 * ===============================
 */



/**
 * Get all events
 */
export const fetchAllEvents = async () => {

 try {

 const response = await api.get("/public/events");

 return {
 status: response.status,
 data: response.data,
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: [],
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to fetch events",
 };

 }

};

/**
 * Get single event by ID
 * GET /api/public/events/{eventId}
 */
export const fetchEventById = async (eventId) => {

 try {

 const response = await api.get(`/public/events/${eventId}`);

 return {
 status: response.status,
 data: response.data,
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to fetch event details",
 };

 }

};

/**
 * Validate booking before submission
 * POST /api/public/events/{eventId}/validate-booking
 */
export const validateBooking = async (eventId, email, mobile) => {

 try {
 const response = await api.post(`/public/events/${eventId}/validate-booking`, {
 email,
 mobile
 });

 return {
 status: response.status,
 data: response.data,
 };

 } catch (err) {
 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Validation failed",
 };

 }

};



/**
 * Book Event
 * POST /api/public/events/{eventId}/book
 */
export const bookEvent = async (eventId, bookingRequest) => {

 try {

 const response = await api.post(
 `/public/events/${eventId}/book`,
 bookingRequest
 );

 return {
 status: response.status,
 data: response.data,
 message: "Event booked successfully",
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to book event",
 };

 }

};


/**
 * Get all bookings of a user
 * GET /api/user/events/bookings/user/{userId}
 */
export const fetchUserBookings = async (userId) => {

 try {

 const response = await api.get(
 `/public/events/bookings/user/${userId}`
 );

 return {
 status: response.status,
 data: response.data,
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: [],
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to fetch bookings",
 };

 }

};


/**
 * Get booking details
 * GET /api/user/events/bookings/{bookingId}
 */
export const fetchBookingById = async (bookingId) => {

 try {

 const response = await api.get(
 `/public/events/bookings/${bookingId}`
 );

 return {
 status: response.status,
 data: response.data,
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to fetch booking details",
 };

 }

};


/**
 * Join Zoom Meeting
 */
export const joinZoomMeeting = (zoomLink) => {

 try {

 if (!zoomLink) {

 return {
 status: 400,
 message: "Zoom link not available",
 };

 }

 window.open(
 zoomLink,
 "_blank",
 "noopener,noreferrer"
 );

 return {
 status: 200,
 message: "Zoom opened successfully",
 };

 } catch (error) {

 return {
 status: 500,
 message: "Failed to open Zoom link",
 };

 }

};


/**
 * Create payment order for event booking
 * POST /api/public/events/{eventId}/create-order
 */
export const createEventPaymentOrder = async (payload) => {
 try {
 const response = await api.post(`/public/events/create-order`, payload);
 return { status: response.status, data: response.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to create payment order" };
 }
};

/**
 * Verify event payment and complete booking
 * POST /api/public/events/verify-payment
 */
export const verifyEventPayment = async (payload) => {
 try {
 const response = await api.post(`/public/events/verify-payment`, payload);
 return { status: response.status, data: response.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Payment verification failed" };
 }
};

/**
 * Get all bookings by email (Guest or Logged-in user)
 * GET /api/public/events/bookings/email/{email}
 */
export const fetchBookingsByEmail = async (email) => {

 try {

 if (!email) {

 return {
 status: 400,
 data: [],
 message: "Email is required",
 };

 }

 const response = await api.get(
 `/public/events/bookings/email/${encodeURIComponent(email)}`
 );

 return {
 status: response.status,
 data: response.data,
 message: "Bookings fetched successfully",
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: [],
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to fetch bookings",
 };

 }

};